import { apiClient } from "../api";
import { SubsidiaryPage, UpdateSubsidiaryPageDto } from "../generated/client";

export const upsertSubsidiaryPage = async (data: UpdateSubsidiaryPageDto): Promise<SubsidiaryPage> => {
    try {
        const response = await apiClient.subsidiariesPage.upsert(data);
        alert("Subsidiary Page saved successfully");
        return response.data;
    } catch (error) {
        console.error("upsert subsidiariesPage:", error);
        throw error;
    }
};

export const getSubsidiaryPage = async (): Promise<SubsidiaryPage | null> => {
    try {
        const response = await apiClient.subsidiariesPage.find();
        return response.data;
    } catch (error) {
        console.error("fetch subsidiaryPage:", error);
        return null;
    }
};